import { render, staticRenderFns } from "./AvailabilitySettings.vue?vue&type=template&id=309a2ec7&scoped=true&"
import script from "./AvailabilitySettings.vue?vue&type=script&lang=ts&"
export * from "./AvailabilitySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a2ec7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VRow,VSpacer,VSwitch})
